<div (window:resize)="onResize($event)" [ngClass]="{'left-99': (sidenav.status | async)===false }" class="nav-container position-fixed h-100 mh-100 sidenav d-flex flex-column flex-shrink-0">
    <div class="sidebar-heading p-0 text-center">
        <img src="/assets/logo.png">
    </div>
    <ul class="nav nav-pills flex-column mb-auto mt-1">
        <li>
            <a routerLink="./dashboard" routerLinkActive="active" class="nav-link link-dark" aria-current="page">
                <i class="material-icons">dashboard</i>
                Dashboard
            </a>
        </li>
        <li>
            <div class="fw-bold divider text-uppercase border-top border-2">Quiz</div>
        </li>
        <li>
            <a routerLink="/wppsi" routerLinkActive="active" class="nav-link link-dark">
                <i class="material-icons">extension</i>
                WPPSI
            </a>
            <a routerLink="/dccs" routerLinkActive="active" class="nav-link link-dark">
                <i class="material-icons">image_search</i>
                DCCS
            </a>
            <a routerLink="/stroop" routerLinkActive="active" class="nav-link link-dark">
                <i class="material-icons">color_lens</i>
                STROOP Test
            </a>
            <a routerLink="/cantab" routerLinkActive="active" class="nav-link link-dark">
                <i class="material-icons">adjust</i>
                CANTAB Test
            </a>
        </li>
        <li>
            <div class="fw-bold divider text-uppercase border-top border-2">Participant</div>
        </li>
        <li>
            <a routerLink="/members" routerLinkActive="active" class="nav-link link-dark">
                <i class="material-icons">groups</i>
                Participants
            </a>
        </li>
        <li>
            <div class="fw-bold divider text-uppercase border-top border-2">Report</div>
        </li>
        <li>
            <a routerLink="/reports" routerLinkActive="active" class="nav-link link-dark">
                <i class="material-icons">summarize</i>
                Report
            </a>
        </li>
        <li>
            <div class="fw-bold divider text-uppercase border-top border-2">Settings</div>
        </li>
        <li>
            <a routerLink="/infos" routerLinkActive="active" class="nav-link link-dark">
                <i class="material-icons">info</i>
                Quiz Info
            </a>
        </li>
        <li>
            <a routerLink="/quiz-images" routerLinkActive="active" class="nav-link link-dark">
                <i class="material-icons">image</i>
                Quiz Graphic
            </a>
        </li>
        <li>
            <a routerLink="/users" routerLinkActive="active" class="nav-link link-dark">
                <i class="material-icons">person</i>
                Admins
            </a>
        </li>
    </ul>
</div>
